import React from "react";
import { useDispatch } from "react-redux";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import { AddToDataConnectSelectedFields } from "../../../actions/dataConnectActions";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import MaterialModal from "../MaterialModal";

interface IFieldShareMetadataModal {
    isOpen: boolean;
    modalProps: {
        fieldNames: Array<string>;
        fieldIds: Array<number>;
        occurs: number;
    };
}

const FieldShareMetadataModal: React.FC<IFieldShareMetadataModal> = ({
    modalProps,
    isOpen,
}: IFieldShareMetadataModal) => {
    const dispatch = useDispatch();
    const selectFieldsMetadata = () => {
        dispatch(AddToDataConnectSelectedFields(modalProps.fieldIds));
        hide();
    };
    const hide = () => dispatch(hideModal("FIELD_SHARE_METADATA"));

    const renderShareFields = () => {
        const renderedFlows: any[] = [];
        if (modalProps.fieldNames && modalProps.fieldNames.length > 0) {
            for (const fieldName of modalProps.fieldNames) {
                renderedFlows.push(
                    <ListItem key={fieldName} className="flow-list-item-delete" divider>
                        {fieldName}
                    </ListItem>
                );
            }
        }
        return renderedFlows;
    };

    return (
        <MaterialModal
            title="Fields with this metadata"
            isOpen={isOpen}
            onClose={hide}
            id="field-metadata"
            maxWidth="lg"
            onPrimaryButtonRequest={selectFieldsMetadata}
            primaryButtonText="Add"
        >
            <div>
                <div className="row">
                    <div className="col-sm-12">These are the {modalProps.occurs} fields sharing this metadata</div>
                </div>
                <strong>Click on add to proceed editing the metadata</strong>
                <div className="row">
                    <div className="col-sm-12">
                        <List>{renderShareFields()}</List>
                    </div>
                </div>
            </div>
        </MaterialModal>
    );
};

export default withModal(FieldShareMetadataModal, "FIELD_SHARE_METADATA");
